<template>
  <div class="Product Product-dialog">
    <div class="page-title">발주관리</div>
    <div>
      <ATable
        ref="table"
        buttons-width="250px"
        max-height="780px"
        :data="items"
        :placeholder="placeholder"
        :search_field="search_field"
        :disable_insert="!has_grant_write"
        hide-pagination
        border
        @row-click="handleClickRow"
        @clicked-create="handleClickedCreate"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector
              ref="period"
              value="1w"
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >검색(F5)</el-button
            >
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column prop="code" label="발주번호" width="100" />
        <el-table-column
          prop="customer_name"
          label="거래처"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품명"
          show-overflow-tooltip
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="order_date"
          label="발주일자"
          :width="$width.date"
        />
        <el-table-column
          prop="valid_date"
          label="입고일"
          :width="$width.date"
        />
        <el-table-column
          prop="order_inbound_state"
          label="입고 상태"
          width="100"
          :formatter="formatInboundState"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button @click="handleClickSaveExcel">상세 다운로드</el-button>
        </div>
      </ATable>
    </div>
    <el-dialog
      title="발주"
      top="0"
      :width="showPyungProcessingCost ? '1500px' : '1300px'"
      custom-class="form-dialog"
      :visible.sync="dialogVisible"
      destroy-on-close
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <OrderForm
        ref="form"
        :data="form_data"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted"
      />
    </el-dialog>
  </div>
</template>

<script>
import export2csv from "@/common/function/export2csv";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { company_info } from "@/common/mixins/company_info";
import { inbound_state } from "@/common/mixins/inbound_process";
import OrderForm from "./OrderForm";

export default {
  name: "Order",
  mixins: [form_container, authority_level, company_info, inbound_state],
  components: { OrderForm },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false
      },
      placeholder: "발주번호,거래처,품명",
      search_field: ["code", "customer_name", "product_name"],
      search: {
        keyword: "",
        status: [],
      },
      items: [],
      dialogVisible: false,
      isShowSearchDetail: false,
      form_data: undefined,
      statuses: [
        { value: "N", label: "진행" },
        { value: "Y", label: "발주" },
        { value: "C", label: "취소" },
      ],
      period: {},
    };
  },
  computed: {
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    searchTags: function() {
      let tags = [];
      let tag = {};
      tag.name = this.util.getPeriodText(this.search.period);
      tag.fixed = true;
      tags.push(tag);
      if (this.search.keyword.length > 0) {
        tag = {};
        tag.name = "검색어: " + this.search.keyword;
        tags.push(tag);
      }
      if (this.search.status.length > 0) {
        tag = {};
        tag.name = "상태: " + this.search.keyword;
        tags.push(tag);
      }
      return tags;
    },
    has_grant_write() {
      return this.isWriteLevel("order");
    },
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  mounted() {
    this.loadConfig()
  },
  created() {},
  methods: {
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSearchDetail() {
      this.isShowSearchDetail = !this.isShowSearchDetail;
      if (!this.isShowSearchDetail) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.keyword.$refs.input.focus();
      });
    },
    /** 데이터 선택 */
    handleClickRow(data) {
      this.openDialog(data);
    },
    /** 신규 등록*/
    handleClickedCreate() {
      this.form_data = undefined; //추가생성시 초기화
      this.openDialog();
    },
    handleChangePeriod(value) {
      this.period = value;
      this.handleClickSearch();
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.api.listOrder(this.period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "발주", res.message);
          return;
        }
        //let product_name = '';
        this.items = res.data;
        for (let i = 0; i < this.items.length; ++i) {
          this.dataArrange(i);
        }
      });
    },
    /**  폼 처리 완료 */
    handleCompleted(action, message) {
      this.dialogVisible = false;
      this.form_data = undefined;
      switch (action) {
        case "create":
        case "delete":
          this.handleClickSearch();
          this.$refs.table.initCurrentPage();
          break;
        case "update":
          this.loadData();
          break;
      }
      if (!message) {
        return;
      }
      this.$notify(message);
      this.loadData();
    },
    dataArrange(index) {
      this.items[index].amount = 0;
      this.items[index].tax = 0;
      this.items[index].cost = 0;
      this.items[index].supply_price = 0;
      this.items[index].price = 0;
      this.items[index].product_name = this.productNaming(this.items[index]);
      for (let j = 0; j < this.items[index].details.length; ++j) {
        this.sumCalculation(index, j);
      }
    },
    productNaming(item) {
      if (item.details.length > 1) {
        return (
          item.details[0].product_name +
          " 외 " +
          (item.details.length - 1) +
          "건"
        );
      } else {
        return item.details[0].product_name;
      }
    },
    sumCalculation(index, j) {
      this.items[index].amount += this.items[index].details[j].amount;
      this.items[index].tax += Math.ceil(
        this.items[index].details[j].cost *
          0.1 *
          this.items[index].details[j].amount
      );
      this.items[index].cost +=
        this.items[index].details[j].cost * this.items[index].details[j].amount;
      this.items[index].price += this.items[index].details[j].price;
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data = clone;
      this.dialogVisible = true;
    },
    resolveTypeFlag(value) {
      return this.system.options.resolve_customer_type_flag(value);
    },
    /**
     * 상세 내역 엑셀 다운로드
     */
    handleClickSaveExcel() {
      let items = [];
      let fields = [
        { value: "code", label: "발주번호" },
        { value: "customer_name", label: "거래처" },
        { value: "product_name", label: "품명" },
        { value: "thickness", label: "두께" },
        { value: "size", label: "가로" },
        { value: "size2", label: "세로" },
        { value: "amount", label: "수량" },
        { value: "unit_name", label: "단위" },
        { value: "pyung", label: "평" },
        { value: "desc", label: "비고" },
      ];
      this.items.forEach((item) => {
        item.details.forEach((d) => {
          let data = {
            code: item.code,
            customer_name: item.customer_name,
            product_name: d.product_name,
            amount: d.amount,
            unit_name: d.unit_name,
            desc: d.desc,
          };
          if (d.size && d.size.indexOf("*")) {
            let arSize = d.size.split("*");
            if (arSize.length == 2) {
              data.size = arSize[0];
              data.size2 = arSize[1];
            } else {
              data.size = d.size;
            }
          } else {
            data.size = d.size;
          }
          if (d.options) {
            data.thickness = d.options.glass_thickness;
            data.pyung = d.options.glass_pyung;
          }
          items.push(data);
        });
      });
      export2csv.export(items, fields, "발주상세");
    },
  },
};
</script>
<style lang="scss" scoped>
.search-head {
  .left-search-head {
    width: calc(100% - 480px);
    padding-right: 10px;
    box-sizing: border-box;
    float: left;
  }

  .search-timer-title {
    display: inline-block;
    text-align: center;
    width: 100px;
  }

  .right-search-head {
    width: 480px;
    float: left;
  }
}

.editer-box {
  margin-top: 20px;
  border: 1px solid #eee;

  .editer-box-head {
    padding-left: 20px;
    border: 1px solid #eee;
    line-height: 48px;

    .editer-box-title {
      font-weight: 700;
    }
  }

  .editer-box-body {
    padding: 20px 30px;
    box-sizing: border-box;
  }

  .split-line {
    clear: both;
    margin: 0 5px;
    height: 2px;
    background: #eee;
  }

  .editer-box-foot {
    padding: 10px;
  }
}

.search-keyword {
  width: 300px;
  margin-right: 20px;
}

.search-status {
  width: 200px;
  margin-right: 20px;
}
</style>
